if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        // 1. Handle the ID mismatch natively so it catches both 'template--123-890' and '890'
        const mediaId = this.openedBy.getAttribute('data-media-id');
        const rawMediaId = mediaId ? mediaId.split('-').pop() : '';
        
        this.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('active');
        });

        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`) || 
                            this.querySelector(`[data-media-id="${rawMediaId}"]`);

        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        // 2. The Anti-Glitch Scroll Fix
        const container = this.querySelector('[role="document"]') || this.querySelector('.product-media-modal__content');
        
        if (container) {
          // Disable Dawn's native CSS smooth scrolling and snapping temporarily
          const originalScrollBehavior = container.style.scrollBehavior;
          const originalScrollSnap = container.style.scrollSnapType;
          
          container.style.scrollBehavior = 'auto';
          container.style.scrollSnapType = 'none';

          // Instantly snap to the correct image using the browser's native engine
          activeMedia.scrollIntoView({ block: 'nearest', inline: 'start', behavior: 'auto' });

          // Restore smooth scrolling AFTER the browser has painted the instant jump
          // requestAnimationFrame ensures we wait for the exact moment the frame renders
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              container.style.scrollBehavior = originalScrollBehavior;
              container.style.scrollSnapType = originalScrollSnap;
            });
          });
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }
    }
  );
}